import React, { useEffect, useState } from 'react';
import { s3Link, ROLES } from '../utils/constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ViewStory from './ViewStory';
import UserStoryCreate from './UserStoryCreate';

import DefaultAvatar from '../images/default_avatar.jpg';
import Avatar from './Avatar';

const UserStories = ({ pu = false }) => {
    const [isPu, setIsPu] = useState(false);
    const [creatorList, setCreatorList] = useState([]);
    const [showStory, setShowStory] = useState(false);
    const [addStory, setAddStory] = useState(false);
    const [userStory, setUserStory] = useState('');

    const handleAddStory = () => {
        setAddStory(!addStory);
    };

    const userInformation = JSON.parse(localStorage.getItem('user'));

    const handleSetShowStory = () => {
        setShowStory(!showStory);
    };

    const handleAddUserID = (userID) => {
        if (userID.following_information) {
            setUserStory(userID.following_information);
        } else {
            setUserStory(userID);
        }

    };

    useEffect(() => {
        const pathname = window.location.pathname.replace('/');
        if (pathname === userInformation.login) {
            setIsPu(false);
        } else {
            setIsPu(true);
        }
    }, []);

    const getCreatorList = async () => {
        if (pu) {
            await axios.get(`/api/users/creatorStories`)
                .then((response) => {
                    setCreatorList(response.data);
                })
                .catch((error) => {
                    console.log({ error });
                });
        } else {
            await axios.get(`/api/users/creatorStoriesSU`)
                .then((response) => {
                    setCreatorList(response.data);
                })
                .catch((error) => {
                    console.log({ error });
                });
        }

    };

    useEffect(() => {
        getCreatorList();
    }, [pu]);

    return (
        <>
            {userInformation.role != ROLES.SU && <UserStoryCreate show={addStory} handleAddStory={handleAddStory} currentUser={userInformation} getCreatorList={getCreatorList} />}
            <div className="suggested-creators-list user-stories-container">
                {creatorList && creatorList.map((creatorListItem, index) => {
                    const user = creatorListItem.following_information ? creatorListItem.following_information : creatorListItem;
                    return user.stories_count > 0
                        ? <a
                            onClick={() => { handleAddUserID(creatorListItem); }}
                            key={index}
                            className="user-story"
                        >
                            <div className="suggested-creators-item">
                                <div className="story-img-wrapper">
                                    <Avatar
                                        size="71"
                                        pu={user}
                                    />
                                </div>
                                <div className="suggested-creators-name">
                                    <p>{user.nicename ? user.nicename : user.display_name}</p>
                                </div>
                            </div>
                        </a>
                        : <div className="suggested-creators-item" key={index}>
                            <div className="story-img-wrapper">
                                <Avatar
                                    size="71"
                                    pu={user}
                                />
                            </div>
                            <div className="suggested-creators-name">
                                <p>{user.nicename ? user.nicename : user.display_name}</p>
                            </div>
                        </div>;
                })}
            </div>
            {userInformation.role !== ROLES.SU &&
                <div className="create-story-btn-cont">
                    <a className="create-story-btn" onClick={handleAddStory}>
                        <FontAwesomeIcon icon={['far', 'image']} /> <span>Add to Story</span>
                    </a>
                </div>
            }
        </>
    );
};
export default UserStories;